import React from 'react';

const TextCol = ({ data, value, tableManager }) => {
  const {
    config: {
      additionalProps: { cell: additionalProps = {} },
    },
  } = tableManager;

  const classNames = ('rgt-cell-inner rgt-text-truncate ' + (additionalProps.className || '')).trim();

  return (
    <>
      <span
        className="fw-bold ps-20"
        title={value}
      >
        {value == '0/0' ? 'N/A' : value}
      </span>
    </>
  );
};

export default TextCol;
